import { CreateOneViewReportReduxState, OneViewReportReducerDispatch, OneViewReportReduxTypes } from "./types"

const ONE_VIEW_REPORT_INITIAL_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateOneViewReportReducer = (state: CreateOneViewReportReduxState = ONE_VIEW_REPORT_INITIAL_STATE, action: OneViewReportReducerDispatch) => {
    switch (action.type) {
        case OneViewReportReduxTypes.ONE_VIEW_REPORT:

            return {
                ...state,
                loading: true
            }
        case OneViewReportReduxTypes.ONE_VIEW_REPORT_SUCCESS:

            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        case OneViewReportReduxTypes.ONE_VIEW_REPORT_ERROR:

            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        default:
            return { ...state }
    }
}

export { CreateOneViewReportReducer }